// Helpers shared by The EasiLinked Perspective hub and post pages.

const DATE_FORMAT = new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "America/Los_Angeles",
});

// Field Notes store their original date as a plain YYYY-MM-DD string; read it as a
// calendar date so it never shifts a day in other time zones.
export const formatDate = (value) => {
    if (!value) return "";
    const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T12:00:00Z`) : new Date(value);
    return Number.isNaN(date.getTime()) ? "" : DATE_FORMAT.format(date);
};

// ~220 words per minute, never less than one minute.
export const readingTime = (words) => (words ? `${Math.max(1, Math.round(words / 220))} min read` : "");

const PLATFORMS = { linkedin: "LinkedIn", facebook: "Facebook" };

export const firstSharedLine = (source) => {
    if (!source?.platform) return "";
    const date = formatDate(source.originalPublishedAt);
    return `First shared on ${PLATFORMS[source.platform] || source.platform}${date ? ` · ${date}` : ""}`;
};

// Sanity image CDN: request a sized, modern-format version of the original.
export const imageUrl = (url, width) => (url ? `${url}?w=${width}&auto=format&fit=max` : "");

export const postPath = (post) => `/perspective/${post.slug}`;

// Articles always have a page; Field Notes only when "Give this note its own page" is on.
export const hasPage = (post) => post?.format === "article" || post?.hasOwnPage === true;

export const isLive = (page) => page?.showOnWebsite === true;
